module.exports = __webpack_public_path__ + "h5/img/banner.acad3f03.jpg";